<template>
  <div class="row">
    <div class="col-12">
      <div class="intro__headline-wrapper">
        <h1 class="intro__headline">
          Adoptuj regularnie pszczoły i podaruj Tacie lub innej bliskiej Ci osobie Pakiet Pszczelego Bohatera lub
          Bohaterki!
          <a href="#scrollTo">
            <div class="intro__arrow"><span></span><span></span><span></span></div>
          </a>
        </h1>
      </div>
      <div class="about__box pt-5 pt-lg-2">
        <div id="scrollTo" class="d-none d-md-block"></div>
        <div class="intro__content pt-lg-2 ">
          Nie masz pomysłu na prezent dla Taty? W tym roku możesz podarować mu coś więcej niż zwykły upominek - spraw,
          aby stał się prawdziwym Pszczelim Bohaterem i stanął na straży swojego pszczelego roju. A my, w ramach
          podziękowania, przygotujemy i wyślemy na podane przez Ciebie adres Pakiet Pszczelego Bohatera! <b>Jeśli
          zdecydujesz się na adopcję regularną do 19 czerwca</b>, pakiet dotrze na wybrany przez Ciebie adres jeszcze przed
          Dniem Ojca! Tylko działając razem, możemy sprawić, że owady zapylające będą mogły bezpiecznie wykonywać swoją
          pracę, która jest fundamentem piramidy życia na naszej planecie!
        </div>
        <div class="d-none d-lg-block text-center"></div>
        <div>
          <Slider/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from "./Slider.vue";

export default {
  name: "Intro",
  data() {
    return {
      title: "Introduction",
    };
  },
  components: {
    Slider,
  },
};
</script>
